import React from 'react'
import '../filtersearch/FilterSearch.css'

const FilterSearch = () => {
  return (
    <div className='filter-search-box'>
        <h2>Filter</h2>
        <div className='scroll-filter-box'>
            <div className='filter-box mb-4'>
                <h3>Age</h3>
                <ul className='radio-box-checked'>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios" id="" value="option1" />
                            <label className="form-check-label" for="">18-29</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios" id="" value="option1" />
                            <label className="form-check-label" for="">30-39</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios" id="" value="option1" />
                            <label className="form-check-label" for="">40-49</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios" id="" value="option1" />
                            <label className="form-check-label" for="">50+</label>
                        </div>
                    </li>
                </ul>
            </div>
            <div className='filter-box mb-4'>
                <h3>Ethnicity</h3>
                <ul className='radio-box-checked'>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios2" id="" value="option2" />
                            <label className="form-check-label" for="">Caucasian</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios2" id="" value="option2" />
                            <label className="form-check-label" for="">Hispanic/Latina</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios2" id="" value="option2" />
                            <label className="form-check-label" for="">European</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios2" id="" value="option2" />
                            <label className="form-check-label" for="">African</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios2" id="" value="option2" />
                            <label className="form-check-label" for="">Asian</label>
                        </div>
                    </li>
                </ul>
            </div>
            <div className='filter-box mb-4'>
                <h3>Rating</h3>
                <ul className='radio-box-checked'>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios3" id="" value="option3" />
                            <label className="form-check-label" for="">High to Low</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios3" id="" value="option3" />
                            <label className="form-check-label" for="">Top Rated</label>
                        </div>
                    </li>
                </ul>
            </div>
            <div className='filter-box mb-4'>
                <h3>Price</h3>
                <ul className='radio-box-checked'>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios4" id="" value="option4" />
                            <label className="form-check-label" for="">High to Low</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios4" id="" value="option4" />
                            <label className="form-check-label" for="">Low to High</label>
                        </div>
                    </li>
                </ul>
            </div>
            <div className='filter-box mb-4'>
                <h3>Sex</h3>
                <ul className='radio-box-checked'>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios5" id="" value="option5" />
                            <label className="form-check-label" for="">Female</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios5" id="" value="option5" />
                            <label className="form-check-label" for="">Male</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios5" id="" value="option5" />
                            <label className="form-check-label" for="">Transgender Male</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios5" id="" value="option5" />
                            <label className="form-check-label" for="">Transgender Female</label>
                        </div>
                    </li>
                </ul>
            </div>
            <div className='filter-box'>
                <h3>Sexuality</h3>
                <ul className='radio-box-checked'>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios6" id="" value="option6" />
                            <label className="form-check-label" for="">Heterosexual</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios6" id="" value="option6" />
                            <label className="form-check-label" for="">Bisexual</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios6" id="" value="option6" />
                            <label className="form-check-label" for="">Homosexual</label>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
  )
}

export default FilterSearch
